import { PREVIEWS_CONFIG } from '../config/preview-config';

/**
 * Obtiene los canales disponibles para un stage
 */
const getAvailableChannels = (stage: string): ('google' | 'meta')[] => {
  return Object.keys(PREVIEWS_CONFIG[stage] || {}) as ('google' | 'meta')[];
};

/**
 * Obtiene las variantes disponibles para un stage + channel
 */
export const getAvailableVariants = (stage: string, channel: string): string[] => {
  return PREVIEWS_CONFIG[stage]?.[channel]?.variants || [];
};

/**
 * Obtiene información del stage: canales y variants disponibles
 */
export const getStageInfo = (stage: string) => {
  const channels = getAvailableChannels(stage);

  // Obtener todas las variants únicas del stage
  const allVariants = new Set<string>();
  channels.forEach(channel => {
    getAvailableVariants(stage, channel).forEach(v => allVariants.add(v));
  });

  return {
    channels,
    allVariants: Array.from(allVariants)
  };
};

/**
 * Obtiene los canales que tienen una variant específica
 */
export const getChannelsWithVariant = (stage: string, variant: string): string[] => {
  const availableChannels = getAvailableChannels(stage);

  return availableChannels.filter(channel => {
    const variants = getAvailableVariants(stage, channel);
    return variants.includes(variant);
  });
};

/**
 * Valida si una combinación stage + channel + variant es válida
 */
export const isValidCombination = (stage: string, channel: string, variant: string): boolean => {
  const variants = getAvailableVariants(stage, channel);
  return variants.includes(variant);
};
